import type { InputHTMLAttributes, LabelHTMLAttributes } from "react";
import { cn } from "../cn";
import { DateInput, TimeInput } from "./DateTime";

const base =
  "rounded-lg border border-steel/40 bg-white px-3 py-2 text-sm text-ink placeholder:text-steel focus:border-brandorange focus:outline-none focus:ring-1 focus:ring-brandorange disabled:bg-cream";

/** Full width unless the caller sets a width (clsx doesn't drop the conflicting class). */
const fullUnlessSized = (className?: string) => !/(^|\s)(w-|flex-1)/.test(className ?? "") && "w-full";

export function Input({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  // Dates and times get the Clevis pickers, not the browser's.
  if (rest.type === "date") return <DateInput className={className} {...(rest as Parameters<typeof DateInput>[0])} />;
  if (rest.type === "time") return <TimeInput className={className} {...(rest as Parameters<typeof TimeInput>[0])} />;
  return <input className={cn(base, fullUnlessSized(className), className)} {...rest} />;
}

export function Label({ className, ...rest }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn("mb-1 block text-xs font-medium text-ink/80", className)} {...rest} />;
}
